export default __webpack_public_path__ + "static/media/point-not-selected.e2fe5448.svg";